export default {
  showAll: 'Zobraziť všetky notifikácie',
  noResults: 'Žiadne notifikácie.'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/components/notifications.js